export default "__VITE_ASSET__PggSAeU___"